var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PageSection", [
    _c(
      "div",
      { staticClass: "container-fluid", class: _vm.$style.container },
      [
        _c(
          "JoinHeading",
          { staticClass: "text-center mb-7", attrs: { level: 2 } },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("join.section.benefits.title")) +
                "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt-3 d-flex flex-column align-items-center" },
          _vm._l(_vm.items, function(item, index) {
            return _c("PageTwoColumnsContent", {
              key: item.image,
              class: _vm.$style.item,
              attrs: {
                image: item.image,
                content: item.content,
                "image-class": item.imageClass,
                "content-class": item.contentClass,
                "image-pull-right": index % 2 === 1
              }
            })
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }